import { action } from 'typesafe-actions'
import { CertificateRequest } from '../../models/RequestModel'
import { Certificate } from '../../models/ResponseModel'
import { ActionTypes } from './types'

export const certificateListRequest = (payload: CertificateRequest) =>
  action(ActionTypes.CERTIFICATE_LIST_REQUEST, payload)

export const certificateLisFullfilled = (response: Certificate[]) =>
  action(ActionTypes.CERTIFICATE_LIST_FULFILLED, response)

export const certificateLisRejected = response =>
  action(ActionTypes.CERTIFICATE_LIST_REJECTED, response)

export const terminalListRequest = () => action(ActionTypes.TERMINAL_LIST_REQUEST)

export const terminalisFullfilled = (response: string[]) =>
  action(ActionTypes.TERMINAL_LIST_FULFILLED, response)

export const setState = (param: { key: string; value: any }) => action(ActionTypes.SET_STATE, param)
export const setSmartCard = (params: any) => action(ActionTypes.SET_SMART_CARD, params)
